import { render, staticRenderFns } from "./FindPain.vue?vue&type=template&id=077ada4a&"
import script from "./FindPain.vue?vue&type=script&lang=js&"
export * from "./FindPain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports